import { Input, Label } from "@eduviaos/ui-kit";
import { clampQuestionCount } from "../../lib/learning/questionCount";
import { usePortalLocale } from "../../lib/i18n/usePortalLocale";

export function QuestionCountPicker({
  id,
  label,
  value,
  min,
  max,
  onChange,
}: {
  id: string;
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
}) {
  const { strings } = usePortalLocale();
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        inputMode="numeric"
        min={min}
        max={max}
        value={String(value)}
        onChange={(e) => onChange(clampQuestionCount(Number(e.target.value), min, max))}
      />
      <p className="text-muted-foreground text-[0.68rem]">{strings.questionRange(min, max)}</p>
    </div>
  );
}
